<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
  <p>{{ text }}</p>
</div>
<div class="modal-footer">
  <button (click)="cancel()" class="btn btn-light" type="button">Cancel</button>
  <button (click)="save()" class="btn btn-primary" type="button">Save</button>
</div>
